const URL_SCHEME_REGEX = /^https?:\/\//

export function getUrlValidationError(value: string): string | null {
	const trimmed = value.trim()
	if (!trimmed) {
		return 'A URL is required'
	}

	if (!URL_SCHEME_REGEX.test(trimmed)) {
		return 'URL must start with http:// or https://'
	}

	try {
		const u = new URL(trimmed)
		if (!['http:', 'https:'].includes(u.protocol)) {
			return 'URL must use http or https'
		}

		return null
	} catch {
		return 'Enter a valid URL'
	}
}